/**
 * Get all focusable elements from context
 */
function getFocusable(context, includeUntabbable) {
    if (typeof context === "undefined") {
        context = document;
    }

    const selectors = ['a[href]',
       'area[href]',
        'input:not([disabled])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        'button:not([disabled])',
        'iframe',
        '[tabindex]',
        '[contentEditable=true]'];

    const query = (includeUntabbable ? selectors : selectors.map(selector => `${selector}:not([tabindex = '-1'])`)).join(',');
    return [...context.querySelectorAll(query)];
}

export default getFocusable;